/**
 * Dynamic service-fee reminder in cart drawer and cart page.
 */
class CartServiceReminder extends HTMLElement {
  constructor() {
    super();
    this.dismissed = sessionStorage.getItem('ff_parts_only_cart') === '1';
    this.unsubscriber = undefined;
    this.needsReminder = false;
  }

  connectedCallback() {
    this.syncCartItemMeta();
    this.mainEl = this.querySelector('[data-cart-service-main]');
    this.partsOnlyEl = this.querySelector('[data-cart-service-parts-only]');
    this.dismissCheckbox = this.querySelector('[data-cart-service-dismiss]');
    this.undoButton = this.querySelector('[data-cart-service-undo]');

    this.dismissCheckbox?.addEventListener('change', () => this.onDismissChange());
    this.undoButton?.addEventListener('click', () => this.undoPartsOnly());

    this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.refresh();
    });
    this.refresh();
  }

  disconnectedCallback() {
    if (this.unsubscriber) this.unsubscriber();
  }

  syncCartItemMeta() {
    const metaEl = this.querySelector('[data-ff-cart-item-meta]');
    if (!metaEl) return;
    try {
      const meta = JSON.parse(metaEl.textContent || '{}');
      window.franchittiCheckoutConfig = window.franchittiCheckoutConfig || {};
      window.franchittiCheckoutConfig.cartItemMeta = {
        ...(window.franchittiCheckoutConfig.cartItemMeta || {}),
        ...meta,
      };
    } catch {
      /* ignore bad JSON */
    }
  }

  onDismissChange() {
    if (this.dismissCheckbox?.checked) {
      sessionStorage.setItem('ff_parts_only_cart', '1');
      this.dismissed = true;
      this.renderState();
    } else {
      this.undoPartsOnly();
    }
  }

  undoPartsOnly() {
    sessionStorage.removeItem('ff_parts_only_cart');
    this.dismissed = false;
    if (this.dismissCheckbox) this.dismissCheckbox.checked = false;
    this.renderState();
  }

  hide() {
    this.hidden = true;
    this.classList.add('cart-service-reminder--hidden');
  }

  show() {
    this.hidden = false;
    this.classList.remove('cart-service-reminder--hidden');
  }

  renderState() {
    if (!window.franchittiCheckoutConfig?.enabled || !this.needsReminder) {
      this.hide();
      return;
    }

    this.show();

    if (this.dismissed) {
      this.mainEl?.setAttribute('hidden', '');
      this.partsOnlyEl?.removeAttribute('hidden');
      return;
    }

    this.partsOnlyEl?.setAttribute('hidden', '');
    this.mainEl?.removeAttribute('hidden');
    if (this.dismissCheckbox) this.dismissCheckbox.checked = false;
  }

  async refresh() {
    if (!window.franchittiCheckoutConfig?.enabled) {
      this.needsReminder = false;
      this.hide();
      return;
    }

    this.syncCartItemMeta();
    this.dismissed = sessionStorage.getItem('ff_parts_only_cart') === '1';

    try {
      const cart = await FranchittiCheckout.fetchCart();
      const { needsServiceReminder } = FranchittiCheckout.analyzeCart(cart);
      this.needsReminder = needsServiceReminder && cart.item_count > 0;
    } catch {
      this.needsReminder = this.dataset.initialShow === 'true';
    }

    this.renderState();
  }
}

customElements.define('cart-service-reminder', CartServiceReminder);
